import React from 'react';
import { FieldRenderProps } from 'react-final-form';
import { useSelector } from 'react-redux';

import { Box, Typography } from '@mui/material';

import { getOptions } from '@bus/options/selectors';
import { getFieldError } from '@core/FinalForm/getFieldError';
import { styles } from '../styles';
import CheckboxGroup from '@components/common/inputs/CheckboxGroup';
import StyleCheckbox from '@components/common/uiKit/StyleCheckbox';

export const RenderStyleField: React.FC<
  FieldRenderProps<(string | number)[]>
> = ({ input, meta }) => {
  const options = useSelector(getOptions('style'));

  return options ? (
    <Box sx={styles.radioWrapper}>
      <Typography variant={'body2'} color={'text.primary'} mb={'16px'}>
        Style
      </Typography>
      <CheckboxGroup
        {...input}
        selectedValues={input.value}
        error={!!getFieldError(meta)}
        helperText={getFieldError(meta)?.id}
        data-testid={`generate-image-studio-style`}
        values={[{ id: 0, name: 'None' }, ...options]}
        control={StyleCheckbox}
        controlVariant={'outlined'}
        selectedKey={'id'}
      />
    </Box>
  ) : null;
};
